module.exports = __webpack_public_path__ + "img/frame (103).f690d8e3.jpg";